var map = {
	"./bind.svg": "17vA",
	"./dashboard.svg": "BCGP",
	"./docker.svg": "JMze",
	"./example.svg": "OOLB",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./fingerprint.svg": "M8Ho",
	"./form.svg": "sTIr",
	"./info.svg": "Yfis",
	"./kubernetes.svg": "XE/g",
	"./link.svg": "KgwQ",
	"./log.svg": "8uFK",
	"./menu.svg": "dH9r",
	"./monitor.svg": "Lu+8",
	"./nested.svg": "798r",
	"./password.svg": "QjmH",
	"./table.svg": "oSYw",
	"./tag.svg": "0dAG",
	"./terminal.svg": "gEzl",
	"./test.svg": "fjDP",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 12